<template>
  <div class="menuitem">
    <router-link :to="{name: option.ruta}" custom v-slot="{href, navigate, isActive}">
      <a class="item" :href="href" :class="{'item_active': isActive}" @click="navigate">
        <!-- <i class="item_icon item_icon__plus material-icons">add</i> -->
        <img class="item_img" :src="mapIcons[option.title]" alt="">
        <!-- <img class="item_img" src="../../../static/images/estadisticas@2x.png" alt=""
          v-if="option.title=='ESTADÍSTICAS'">
        <img class="item_img" src="../../../static/images/puntosdecontrol@2x.png" alt=""
          v-if="option.title=='PUNTO DE CONTROL'">
        <img class="item_img" src="../../../static/images/Settings@2x.png" alt="" v-if="option.title=='CONFIGURACIÓN'"> -->
        <div class="item_title">{{option.title}}</div>
        <i class="item_icon material-icons">chevron_right</i>
      </a>
    </router-link>

    <div v-if="subitemCount && isItemActive">
      <router-link :to="{name: it.ruta}" custom v-slot="{href, navigate,isExactActive}" v-for="(it, index) in option.subitems" :key="index">
        <a class="subitem"
          :class="{'subitem_active': isExactActive}"
          :href="href"
          @click="navigate"
          >
          <label class="subitem_title">{{it.nombre}}</label>
          <i class="item_icon item_icon__next material-icons">chevron_right</i>
        </a>
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "MenuItem",
  props: {
    option: {
      type: Object,
      default() {
        return {
          title: "Mook",
          subitems: [
            {
              nombre: String,
              ruta: String
            }
          ],
          ruta: String
        };
      }
    }
  },
  data() {
    return {
      subitemNumber: 0,
      mapIcons: {
        DASHBOARD: "../../../static/images/dashboard@2x.png",
        ESTADÍSTICAS: "../../../static/images/estadisticas@2x.png",
        'PUNTO DE CONTROL': "../../../static/images/puntosdecontrol@2x.png",
        CONFIGURACIÓN: "../../../static/images/Settings@2x.png",
        ALERTAS: "../../../static/images/warning.png",
        "ALERTAS DASHBOARD": "../../../static/images/warning.png",
        INDICADORES: "../../../static/images/gas.png",
        "DESCARGA DE HISTÓRICO": "../../../static/images/download.png",
      }
    };
  },
  computed: {
    ...mapGetters(["showSidebar", "getColorChildren", "role"]),
    ...mapState(["isMaster"]),
    isItemActive(){
      // console.log(`isItemActive(${this.option.title}): `, {ruta: this.option.ruta, area: this.$route.meta.area});
      return (this.option.ruta === this.$route.meta.area) || (this.$route.meta.area === 'settings' && ["listuser","edificios","diseno"].includes(this.option.ruta));
    },
    subitemCount: function () {
      // console.log(`subitemCount(${this.option.title}): `, {subitemcountInit: Number(this.subitemNumber), subitemcountProps: Number(this.option.subitems.length), subitemcountTotal: Number(this.subitemNumber) + Number(this.option.subitems.length)});
      
      return Number(this.subitemNumber) + Number(this.option.subitems.length);
    },
    itemName() {
      if (this.$route.name == "businessEdit" || this.$route.name == "businessCreate") {
        return "businesses"
      }
      if (this.$route.name == "usersMasterCreate" || this.$route.name == "updateUserMaster") {
        return "usersMaster"
      }
      return this.$route.name;
    }
  }
};
</script>
<style lang="scss" scoped>
.menuitem {
  font-family: "Roboto";
  width: 100%;
  font-size: 17px;
  cursor: pointer;
}

.item,
.subitem {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  cursor: pointer;
}

.item_icon {
  padding: 0px 10px;
  color: #4f4f4f;

  &__plus {
    transform: scale(0.8);
  }

  &__next {
    color: #505050;
  }

  // &--noShow{
  //   // display: none;
  //   // opacity: 0;
  // }
}

.item_title {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  color: #5f5f5f;
}

.subitem {
  border-bottom: 1px solid #dbdbdb;
  color:#2c3e50;
  // transition: all 1s ease;
}

.subitem_title {
  padding-left: 43px;
  cursor: pointer;
  word-break: normal;
  max-width: 300px;
  text-align: left;
}

.item_active {

  .item_title,
  i {
    color: #1fb6ff;
    font-weight: bold;
  }
}

.subitem_active {

  .subitem_title,
  i {
    color: #1fb6ff;
    font-weight: bold;
  }
}

.item {
  border-bottom: 1px solid #dbdbdb;
}

.item_title {
  margin: 5px;
  padding: 5px;
}

.item_img {
  height: 20px;
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Componentes/MenuItem.vue